﻿{
  "favoriteBoardmakerSoftware": "suosikki Boardmaker-ohjelmisto",
  "planDetailsStartTrial": "Aloita maksuton kokeilusi välittömästä, joka sisältää pääsyn 30 päivän ajaksi!",
  "community": {
    "summary": "Hyödynnä kaltaistesi vanhempien, kouluttajien ja terapeuttien jakamia valmiita materiaaleja, joihin sinulla on pääsy! Säästä aikaa etsimällä ja suodattamalla aktiviteetteja ja mallipohjia, lisää ne sitten yksinkertaisesti tilillesi ja olet valmis muokkaamaan ja käyttämään Boardmaker-ohjelmistoasi. 60 000 MAKSUTTOMAN paino- ja vuorovaikutteisen aktiviteetin ja yli 500 000 jäsenen kanssa, mitä enää odottelet?",
    "topReasons": {
      "header": "Huippusyyt kirjautua käyttäjäksi myBoardmaker Communityyn",
      "points": [
        "Jaa suurenmoiset luomasi aktiviteetit",
        "Käytä tehokkaita hakuominaisuuksia löytääksesi tarvitsemasi",
        "Löydä aktiviteetteja, jotka ovat ammattimaisesti Boardmaker koulutustiimin luomia",
        "Etsi aktiviteetteja, jotka ovat linjattuja Common Core -standardien mukaisesti",
        "Liity ryhmiin, jotka ovat kiinnostuksesi kohteiden mukaisia"
      ]
    },
    "summaryEnd": "Jaa ja tutki vuorovaikutteisia ja painomateriaaleja, jotka toimittavat käyttäytymisen tukea ja edistävät opiskelijoiden itsenäisyyttä sekä taitojen kehittämistä, kaikki MAKSUTTOMASTI.",
    "features": [
      {
        "featureTitle": "Etsi",
        "featureDescription": "Löydä sovellettu oppisuunnitelma, visuaaliset aikataulut, viestintätaulut, standardien mukaiset koulutusaktiviteetit, sekä muut tuet, joita on kehitetty ja käytetään vanhempien, terapeuttien ja kouluttajien toimesta."
      },
      {
        "featureTitle": "Jaa",
        "featureDescription": "Lataa aktiviteetteja, joita olet luonut, osallistu keskusteluihin, muodosta julkisia ja yksityisiä ryhmiä jakamista ja paljon muuta varten."
      },
      {
        "featureTitle": "Käyttö",
        "featureDescription": "Tallenna aktiviteettisi verkkoon ja siirry niihin miltä tahansa tietokoneelta."
      },
      {
        "featureTitle": "Liitä",
        "featureDescription": "Ole yhteydessä muiden kanssa, jotka opettavat samaa ainetta tai luokkatasoa, vaihda ideoita vanhempien kanssa, jotka kohtaavat samoja haasteita kuin sinä itse, ja jaa ratkaisuja, joita olet luonut."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 tai myöhempi"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 tai myöhempi"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 tai myöhempi"]
      ],
      "browser": [
        ["Chrome", "v49.0", "nykyinen"],
        ["Firefox", "v38.0", "nykyinen"],
        ["Safari", "v11.0", "nykyinen"],
        ["Edge", "v83.0.478.45", "nykyinen"],
        ["Internet Explorer", "v10.0", "v11.0 tai myöhempi"]
      ]
    }
  },
  "personal": {
    "summary": "Tuo Boardmakerin teho helposti kotiisi. myBoardmaker Personal -tilaussuunnitelma antaa sinulle kyvykkyyden aktiiviseen rooliin lapsesi menestyksessä toimittamalla sinulle johdonmukaisuutta kodin, koulun ja terapian välillä, vaihtoehdon laajentaa oppimista koulupäivän ja jopa kouluvuoden ulkopuolella. Verkottaudu muiden vanhempien kanssa Boardmaker-yhteisössä jakaaksesi ja saadaksesi ideoita moneen muuhunkin sisältöön.",
    "topReasons": {
      "header": "Huippusyitä kirjautua käyttäjäksi myBoardmaker Personal -sisältöön",
      "points": [
        "Tuo osallistavia ja vuorovaikutuksellisia aktiviteetteja mille tahansa tietokoneelle tai iPadille",
        "Tulosta aktiviteetteja aina tarvitessasi niitä",
        "Omaksu vanhempana aktiivinen rooli lapsesi oppimiselle kotona",
        "Ota hauskoja ja kiinnostavia materiaaleja kaikkialle, minne sinun tarvitsee mennä ja luo tai muokkaa aktiviteetteja miltä tahansa tietokoneelta"
      ]
    },
    "summaryEnd": "Aloita maksuton kokeilujaksosi tänään, joka sisältää täyden pääsyn 30 päivän ajaksi!",
    "features": [
      {
        "featureTitle": "Luo ja muokkaa",
        "featureDescription": "Luo ja muokkaa symbolein mukautettuja aktiviteetteja, kuten visuaaliset aikataulut päiväsi suunnittelemiseksi, yksilölliset kirjat ja oppimismateriaalit, sekä käyttäytymistuet! Yli 80 000 symbolia valittavana kirjastosta, sekä uusia lisätään aina kahden viikon välein, mahdollisuudet ovat loputtomia. Tarvitsetko lisää? Käytä verkkohakumme toimintoa tuodaksesi kaikkia media-tiedostoja projektiisi."
      },
      {
        "featureTitle": "Tulosta ja toista",
        "featureDescription": "Tulosta omia aktiviteettejasi tai kaikkea, mitä voit löytää Boardmaker-yhteisössä, suoraan verkkoselaimestasi ja käytettäväksi lapsesi kanssa. Pyritkö lisäämään osallistumista? Kokeile vuorovaikutteisia mallipohjiamme ja aktiviteettejamme. Lapset ja aikuiset voivat helposti toistaa aktiviteetteja maksuttoman Student Center -sovelluksen välityksellä taulutietokoneellaan tai viestintälaitteellaan."
      },
      {
        "featureTitle": "Opeta ja laajenna",
        "featureDescription": "Kaapelikäynnistä lapsesi kielelliset ja kirjalliset taidot pääsyllä kolmeen helppokäyttöiseen opiskeluohjelmaamme. Aloita Core First Learning -sisällön kanssa, joka on työkalu, jolla helpotetaan lapsesi oppimaan korkeatiheyksisten ydinsanojen merkityksiä, käyttöä ja asettamista. Ihanteellinen yksilöille, jotka käyttävät ydinpohjaisia augmentatiivisia viestintäjärjestelmiä tai niitä, jotka opettelevat lukemaan! Sovella näitä uusia taitoja luokkatason kirjallisuuteen ottamalla käyttöön Book Bridge, ja aloita sitten rakentamaan maailman tietoutta historian, maantieteen, elämän ja kulttuurin tutkimisella Expedition Education -sisällön avulla."
      },
      {
        "featureTitle": "Löydä ja jaa",
        "featureDescription": "Miksi keksiä rengas uudelleen? Valitse yli 60 000 MAKSUTTOMAN ja valmiin tulostus- ja vuorovaikutteisen aktiviteetin joukosta ja 1 100 luokitellun julkisen ryhmän joukosta Boardmaker-yhteisössä - maailman suurin kaltaisensa jakoyhteisö. Voit myös ladata aktiviteetteja, joita olet luonut myBoardmaker Community -tilillä ja jakaa niitä vanhempien, terapeuttien tai opiskelijasi tukitiimin kanssa."
      },
      {
        "featureTitle": "Valvo ja jäljitä",
        "featureDescription": "Valvo ja jäljitä lapsesi etenemistä näiden työskennellessä aktiviteettien kanssa, varmistaaksesi heidän onnistumisensa ja auttaen sinua löytämään kaikkein tehokkaimman lähestymistavan."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 tai myöhempi"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 tai myöhempi"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 tai myöhempi"]
      ],
      "browser": [
        ["Chrome", "v49.0", "nykyinen"],
        ["Firefox", "v38.0", "nykyinen"],
        ["Safari", "v11.0", "nykyinen"],
        ["Edge", "v83.0.478.45", "nykyinen"],
        ["Internet Explorer", "v10.0", "v11.0 tai myöhempi"]
      ]
    }
  },
  "professional": {
    "summary": "Boardmaker Online Professional on kaikkein täysimittaisin järjestelmä erityisopetuksen opettajia, puhe- ja kielipatologeja, toimintaterapeutteja, käyttäytymisterapeutteja ja useita muita varten, jotta voidaan löytää, luoda, organisoida ja toimittaa mukautettuja visuaalisia tukia, symbolipohjaista viestintää ja terapian aktiviteetteja, joissa kohdennutaan opiskelijoidesi tarpeisiin luokassasi tai tapaustesi lukumäärässä.",
    "topReasons": {
      "header": "Huippusyyt myBoardmaker Professional -käyttäjäksi kirjautumiselle",
      "points": [
        "Manage and assign opiskelija-aktiviteetteja mistä vain ja miltä tahansa tietokoneelta",
        "Käytä laajoja vakiolinjattuja näyteaktiviteetteja tai luo omasi",
        "Opiskelijat voivat siirtyä ohjeistettuihin aktiviteetteihin miltä tahansa tietokoneelta tai iPadilta koulussa tai kotona",
        "Kerää tietoja ja jäljitä opiskelijoiden edistymistä kohti IEP-tavoitteita ja koulutuksellisia standardeja",
        "Sisään rakennetut työkalut auttavat sinua tekemään yhteistyötä ja jakamaan muiden tiimijäsenten kanssa"
      ]
    },
    "summaryEnd": "Aloita maksuton kokeilujaksosi tänään, joka sisältää täyden pääsyn 30 päivän ajaksi!",
    "features": [
      {
        "featureTitle": "Luo ja muokkaa",
        "featureDescription": "Luo ja muokkaa symbolein mukautettuja aktiviteetteja, kuten visuaaliset aikataulut päiväsi suunnittelemiseksi, yksilölliset kirjat ja oppimismateriaalit, sekä käyttäytymistuet! Yli 80 000 symbolia valittavana kirjastosta, sekä uusia lisätään aina kahden viikon välein, mahdollisuudet ovat loputtomia. Tarvitsetko lisää? Käytä verkkohakumme toimintoa tuodaksesi kaikkia media-tiedostoja projektiisi."
      },
      {
        "featureTitle": "Tulosta ja toista",
        "featureDescription": "Tulosta omia aktiviteettejasi tai kaikkea, mitä voit löytää Boardmaker-yhteisössä, suoraan verkkoselaimestasi ja käytettäväksi lapsesi kanssa. Pyritkö lisäämään osallistumista? Kokeile vuorovaikutteisia mallipohjiamme ja aktiviteettejamme. Lapset ja aikuiset voivat helposti toistaa aktiviteetteja maksuttoman Student Center -sovelluksen välityksellä taulutietokoneellaan tai viestintälaitteellaan."
      },
      {
        "featureTitle": "Opeta ja laajenna",
        "featureDescription": "Auta oppijaasi ottamaan seuraava askel koulutuspolullaan pääsyllä kolmeen mukaisesti linjattuun opetusohjelmaan. Sisällytettynä myBoardmaker -tilaussuunnitelmaan, Boardmaker Instructional Solutions toimitetaan yli 140 vaiheittaisella oppituntisuunnitelmalla, yli 1 500 erillisellä ja standardein linjatuilla aktiviteeteilla, yli 300 tulostettavalla kirjalla, joihin on pääsy, luokkahuoneen hallintatyökaluilla, pistokokeilla, peleillä, resepteillä ja vielä monella muulla sisällöllä!"
      },
      {
        "featureTitle": "Löydä ja jaa",
        "featureDescription": "Miksi keksiä rengas uudelleen? Valitse yli 60 000 MAKSUTTOMAN ja valmiin tulostus- ja vuorovaikutteisen aktiviteetin joukosta ja 1 100 luokitellun julkisen ryhmän joukosta Boardmaker-yhteisössä - maailman suurin kaltaisensa jakoyhteisö. Voit myös ladata aktiviteetteja, joita olet luonut myBoardmaker Community -tilillä ja jakaa niitä vanhempien, terapeuttien tai opiskelijasi tukitiimin kanssa."
      },
      {
        "featureTitle": "Valvo ja jäljitä",
        "featureDescription": "Valvo ja jäljitä lapsesi etenemistä näiden työskennellessä aktiviteettien kanssa, varmistaaksesi heidän onnistumisensa ja auttaen sinua löytämään kaikkein tehokkaimman lähestymistavan."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 tai myöhempi"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 tai myöhempi"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 tai myöhempi"]
      ],
      "browser": [
        ["Chrome", "v49.0", "nykyinen"],
        ["Firefox", "v38.0", "nykyinen"],
        ["Safari", "v11.0", "nykyinen"],
        ["Edge", "v83.0.478.45", "nykyinen"],
        ["Internet Explorer", "v10.0", "v11.0 tai myöhempi"]
      ]
    }
  },
  "organization": {
    "summary": "Boardmaker Online Organization tukee monialaista tiimiä toimittamalla mukautettuja aktiviteetteja, käyttäytymistukea ja edistymisen mittausta kohti standardeja ja tavoitteita. \n\nBoardmaker Online cloud-pohjainen järjestelmä toimittaa puitekehyksen johdonmukaisuutta ja yhteistyötä varten koko organisaation läpi ja mahdollistaa henkilöstön työn mistä vain. Se toimittaa myös pääsyn yli 60 000 esivalmistetun aktiviteetin kokonaisuuteen, kolme täyttä opinto-ohjelmaa ja yli 80 000 kuvaviestintäsymbolia aloittamaan oppituntien suunnittelun. Nyt henkilöstösi voi nopeasti toimittaa painotuotteet ja vuorovaikutteiset aktiviteetit opiskelijoilleen tai asiakkailleen käyttämällä Boardmaker Student Center -sisältöä laajentamaan oppimista ja terapiaa. Kaikki painikkeen painalluksella!\n\nTarkastele henkilöstön käyttöä ja tehokkuuden parantamista koko organisaatiosi läpi ja mahdollisuudella hallita tilejä ja dataa keskitetysti, sekä pitkälle kehitettyjen jako- ja yhteistyötyökalujen kanssa.",
    "topReasons": {
      "header": "Huippusyyt kirjautua käyttäjäksi myBoardmaker Organization -sisältöön",
      "points": [
        "Pilvipohjainen järjestelmä toimittaa jatkuvuutta ja yhteistoimintaa koko organisaation läpi ja mahdollistaa henkilöstön työskentelevän mistä vain",
        "Laajamittainen näyteaktiviteettien kirjasto on jo linjattu Yliopisto- ja Uravalmiusstandardeihin ja osavaltiosi erityisiin standardeihin",
        "Opiskelijat voivat siirtyä ohjeistaviin aktiviteetteihin miltä tahansa tietokoneelta, mistä vain",
        "Aktiviteetit voidaan liittää IEP-tavoitteisiin demonstroida opiskelijasaavutuksia",
        "Välitön siirtyminen opiskelijan suoritustietoihin ja henkilöstökäyttöön, kaikki yhdestä järjestelmästä"
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Luo ja muokkaa",
        "featureDescription": "Luo ja muokkaa symbolein mukautettuja aktiviteetteja, kuten visuaaliset aikataulut päiväsi suunnittelemiseksi, yksilölliset kirjat ja oppimismateriaalit, sekä käyttäytymistuet! Yli 80 000 symbolia valittavana kirjastosta, sekä uusia lisätään aina kahden viikon välein, mahdollisuudet ovat loputtomia. Tarvitsetko lisää? Käytä verkkohakumme toimintoa tuodaksesi kaikkia media-tiedostoja projektiisi."
      },
      {
        "featureTitle": "Tulosta ja toista",
        "featureDescription": "Tulosta omia aktiviteettejasi tai kaikkea, mitä voit löytää Boardmaker-yhteisöstä, suoraan näiden verkkoselaimesta Pyritkö lisäämään osallistumista? Rohkaise tiimiäsi kokeilemaan vuorovaikutteisia mallipohjiamme ja aktiviteettejamme. Opiskelijat voivat helposti toistaa aktiviteetteja maksuttoman, täydellä pääsyllä varustetun Student Center -sovelluksen kanssa ilman tarvittavaa internet-yhteyttä."
      },
      {
        "featureTitle": "Opeta ja laajenna",
        "featureDescription": "Toimita henkilöstöllesi pääsy kolmeen tukevaan, standardien mukaisesti linjattuun opintosuunnitelmaan, kaikki sisällytettyinä myBoardmaker Organization ­tilaussuunnitelmaan. Boardmaker Instructional Solutions toimitetaan yli 140 vaiheittaisella oppituntisuunnitelmalla, yli 1 500 erillisellä ja standardein linjatuilla aktiviteeteilla, yli 300 tulostettavalla kirjalla, joihin on pääsy, luokkahuoneen hallintatyökaluilla pistokokeilla, peleillä, resepteillä ja vielä monella muulla sisällöllä!"
      },
      {
        "featureTitle": "Määritä ja jäljitä",
        "featureDescription": "Boardmaker Online Organization -tilin avulla, henkilöstö voi määrittää mukautettuja ja tasoperusteisia aktiviteetteja rajoittamattomalle opiskelijamäärällä jäljittäen näiden yksilölliset edistymiset heidän IEP-tavoitteitaan ja osavaltion ja paikallisten standardien kokonaisuuksia vasten. He voivat sitten käyttää Progress Monitoring -työkalua nopeasti heijastaen heidän opiskelijoidensa suorituskykyä ja helposti raportoida heidän menestyksensä. Määritetyt aktiviteetit suoritettuina kotona, ovat myös jäljitettyjä, joten he voivat helposti hallita läksyjä ja muodostaa kumppanuuksia lapsen perheen kanssa laajentamaan oppimista luokan ulkopuolella."
      },
      {
        "featureTitle": "Löydä ja jaa",
        "featureDescription": "Miksi keksiä rengas uudelleen? Valitse yli 60 000 MAKSUTTOMAN ja valmiin tulostus- ja vuorovaikutteisen aktiviteetin joukosta ja 1 100 luokitellun julkisen ryhmän joukosta Boardmaker-yhteisössä - maailman suurin kaltaisensa jakoyhteisö. Voit myös ladata aktiviteetteja, joita olet luonut myBoardmaker Community -tilillä ja jakaa niitä vanhempien, terapeuttien tai opiskelijasi tukitiimin kanssa."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Kustannussäästöt",
        "advantagePoints": [
          "Yksinomaiset mukautetut organisaatiopaketit yli 5 käyttäjän tileille",
          "Pilvipohjaiset palvelut mahdollistavat lisenssien helpon uudelleen määrittämisen henkilöstön tilitapahtumana",
          "Kappalemääräinen hinnoittelu",
          "Usean tuotteen paketit",
          "Säästöt usean vuoden läpi"
        ]
      },
      {
        "advantageTitle": "Menestystä kaikille",
        "advantagePoints": [
          "Tutkimuspohjaiset ja valmiit aktiviteetit",
          "Noudattaen Universaalin suunnittelun periaatteita oppimista varten, sovitetut koulutusmateriaalimme tekevät oppisuunnitelmista saavutettavia yksilöitä varten, joilla on useita kyvykkyyksiä",
          "Mukautettu opintosuunnitelma suo tasa-arvoisen pääsyn kaikille",
          "Resurssit käytettävissä kapsuloimaan parhaita käytäntöjä ja varmistaen, että saat mahdollisimman paljon irti ratkaisuistasi"
        ]
      },
      {
        "advantageTitle": "Tukee standardeja ja vaatimuksia",
        "advantagePoints": [
          "Ratkaisut suunniteltuja erityisesti opettamaan ja mittaamaan edistymistä kohti yliopistoa ja uravalmiuksien standardeja",
          "Suuri määrä ratkaisuja, jotka tukevat Universaalia suunnittelua oppimista varten, Jokainen lapsi menestyy ja Vammaisten henkilöiden koulutus -lakien vaatimukset",
          "Jäljitä ja raportoi edistymistä kohti yksittäisiä koulutussuunnitelmien tavoitteita automaattisesti tietokojelautojen välityksellä"
        ]
      },
      {
        "advantageTitle": "Helppo käyttöönotto organisaatiossa",
        "advantagePoints": [
          "Mahdollistaa järjestelmänvalvojien toimittavan ja ottavan tilejä käyttöön etätoimintoina sekuntien kuluessa",
          "Joustavat ja skaalautuvat organisaation käyttöönottovaihtoehdot",
          "Kaikki pilvipohjaiset ratkaisut isännöidään korkeasti varmistetussa tason 1 tietokeskuksessa",
          "Maksuttomat automaattiset pilvipohjaiset jännittävät ominaisuudet ja resurssit"
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 tai myöhempi"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 tai myöhempi"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 tai myöhempi"]
      ],
      "browser": [
        ["Chrome", "v49.0", "nykyinen"],
        ["Firefox", "v38.0", "nykyinen"],
        ["Safari", "v11.0", "nykyinen"],
        ["Edge", "v83.0.478.45", "nykyinen"],
        ["Internet Explorer", "v10.0", "v11.0 tai myöhempi"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "Seuraavan sukupolven Boardmaker-ohjelmisto on saapunut!  Boardmaker 7 sisältää parhaat ominaisuudet kaikista aikaisemmista Boardmaker-sisällöistä ja muodostaa niistä yhden monialustaisen, monikielisen sovelluksen.  Boardmaker 7 sisältää ominaisuutena käyttäjärajapinnan, joka asettaa tarvitsemasi työkalut käytettäviksesi.  Se sisältää viimeisimmät PCS-symbolit, ja se on kuitenkin taaksepäin yhteensopiva kaikkien aikaisempien taulujesi ja aktiviteettiesi kanssa. Tämä uusi ohjelmisto mahdollistaa sinun luovan ja toimittavan sovellettavan oppijakson ja viestinnän tuet nopeammin kuin koskaan aikaisemmin.",
    "topReasons": {
      "header": "Huippusyyt ostaa Boardmaker 7 -ohjelmisto",
      "points": [
        "Muokkaa, tulosta ja toista kaikkia vanhoja Boardmaker-tiedostojasi",
        "Intuitiivinen, moderni rajapinta sisään rakennetuilla vihjeillä ja koulutusmateriaaleilla",
        "Uskomattomia mallipohjia, jotka ovat nopeita ja helppoja mukauttaa",
        "Löydä nopeasti tarvitsemasi symbolit ja kuvat"
      ]
    },
    "summaryEnd": "Lataa maksuton 30 päivän kokeiluversio välittömästi!",
    "features": [
      {
        "featureTitle": "Avaa kaiken valmistamasi",
        "featureDescription": "Älä hukkaa vuosien kovan työn tuloksia…  Boardmaker 7 -ohjelmiston kanssa voit avata minkä tahansa Boardmaker v5, Boardmaker v6, tai Boardmaker Studion kanssa valmistellun tiedoston.  Muunnos on nopea ja tarkka, joten jopa monimutkaiset vuorovaikutteiset aktiviteetit toimivat ja näyttävät alkuperäisiltä."
      },
      {
        "featureTitle": "Helppo, helppo, helppo",
        "featureDescription": "Käyttäjät ovat puhuneet!  Laajamittaisen kaltaisesi käyttäjäkunnan testaamisen tuloksena, Boardmaker 7 -ohjelmiston käyttöliittymä on moderni, tervetulleeksi toivottava ja intuitiivinen.  Sisään rakennetut vihjeet ja koulutusmateriaalit rohkaisevat sinua tutkimaan, laajentamaan taitojasi ja kaikkein tärkeimpänä, tukemaan oppilaitasi."
      },
      {
        "featureTitle": "Nopea / aikaa säästävä",
        "featureDescription": "Uudelleen suunnitelluilla mallipohjilla sekä painotuotteita, että vuorovaikutteisia aktiviteetteja varten, tulet hämmästymään sen osalta, mitä voit saavuttaa muutamassa minuutissa.  Saat valmiiksi aikataulun tai sosiaalisen kertomuksen hetkessä, vapauttaen huomiosi oppilaille, joista huolehdit.  Boardmaker tekee myös helpoksi mukauttaa mitä olet luonut, joten sinulla on ihanteellinen yhdistelmä nopeutta ja joustavuutta."
      },
      {
        "featureTitle": "Ylivertainen symbolihaku",
        "featureDescription": "Symbolit ovat keitä me olemme. Boardmaker 7 sisältää parannetun symbolien haun toiminnon, sekä intuitiivisen tavan selata symboleja luokittain… mutta tämä on vain alkua.  Voit etsiä sanojen osia, sanavastaavuuksia, yksittäisiä äänteitä, sekä konsonantti-/vokaaliyhdistelmiä. Tämä on kaikkein voimakkain käytettävissä oleva hakutyökalu!  Ja mikäli et voi löytää kyseistä erikoissymbolia, yhdistetty verkkohaku ja kameratyökalut mahdollistavat valokuvien lisäämisen nopeasti ja helposti."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 tai myöhempi"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 tai myöhempi"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 tai myöhempi"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 tai myöhempi"],
        ["Android", "Tobii Dynavox T-Series Devices", ""]
      ],
      "eyeTracker": [
        [
          "PCEye Mini,",
          "PCEye Explore,",
          "PCEye Go,",
          "EyeMobile,",
          "I-12,",
          "I-15"
        ]
      ]
    }
  }
}
